// „Element powyżej” dla operacji poziom niżej (⇥ / Tab / gest / przeciąganie) — spec/lista-zadan.md →
// Przyciski przesuwania. Liczone po WIDOCZNEJ kolejności w widoku, nie po pozycji w bazie (serwer nie zna
// filtrów; incydent 2026-09-11). Czysty moduł bez DOM — tests/unit/reorder_core_test.ts.

/**
 * Poprzednie widoczne rodzeństwo `id` w liście `visibleIds` (kolejność DOM na jednym poziomie),
 * z pominięciem `exclude` (np. pozostałych zaznaczonych w multi-select). null = brak.
 */
export function prevVisibleSibling(visibleIds: string[], id: string, exclude: Iterable<string> = []): string | null {
  const ex = new Set(exclude);
  const i = visibleIds.indexOf(id);
  for (let j = i - 1; j >= 0; j--) {
    if (!ex.has(visibleIds[j])) return visibleIds[j];
  }
  return null;
}
